import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../../hooks/NotificationContext';
import { slackExchange } from '../../../modules/notification';

const SlackCallbackComponent = () => {
  const navigate = useNavigate();
  const { addNotification } = useNotification();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    async function finishSlackAuth() {
      const query = new URLSearchParams(window.location.search);
      const code = query.get('code');
      const state = query.get('state'); // projectId

      if (!code || !state) {
        setError('Invalid Slack callback parameters.');
        setLoading(false);
        return;
      }

      try {
        await slackExchange(state, code);
        addNotification('success', 'Slack connected successfully!');
        navigate(`/project/${state}/configurations?tab=notifications`);
      } catch (err) {
        setError(err.message || 'Failed to connect Slack.');
        setLoading(false);
      }
    }

    finishSlackAuth();
  }, [navigate, addNotification]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
      }}
    >
      {loading ? (
        <>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Connecting to Slack...</Typography>
        </>
      ) : (
        <>
          <Typography color="error" sx={{ mb: 2 }}>
            {error}
          </Typography>
          <Button variant="contained" onClick={() => navigate(`/dashboard`)}>
            Go back to dashboard
          </Button>
        </>
      )}
    </Box>
  );
};

export default SlackCallbackComponent;